import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'
import ConfigurablePosition from './_configurable-position.js'
import FlexPaneSeparator from './_flex-pane-separator.js'

export default {
  name: 'FlexPane',
  values: {
    createStackingContext: false,
    style: {
      zIndex: undefined,
      overflow: undefined,
      $mixin: [
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurableSize,
        },
        {
          configSet: ConfigurablePosition,
        },
      ],
    },
    itemSpacing: undefined,
    useSpacingSeparator: false,
    separator: {
      configSet: FlexPaneSeparator,
      configValues: {},
    },
    nthSeparator: undefined,
  },
  meta: {
    extendable: false,
  },
}
